<div class="tse-cont" *ngIf="isUserDeviceOnline">
    <!-- Jitsi Meeting Layout (full screen) -->
    @if (isMeetPage) {
        <app-jitsi-meeting />
    }
    @else if (isDocumentRoute()) {
        <!-- Document Layout - rendered via router, no header/sidebar needed -->
        <router-outlet></router-outlet>
    }
    @else {
        <!-- Main Application Layout (header + sidebar + content) -->
        <header>
            @defer (on immediate) {
                <app-nav-bar (toggleSidenav)="toggleSidenav()"></app-nav-bar>
            }
        </header>
        <mat-sidenav-container class="sidebar-container" autosize>
            <mat-sidenav
                    *ngIf="isLoggedIn"
                    [mode]="sideNavMode"
                    [opened]="true"
                    class="matSideNav"
                    [autoFocus]="false"
                    disableClose="true"
                    [ngClass]="{
                        'sidenav-expanded': !isShowingIconsOnlyBar || (isShowingIconsOnlyBar && isSidenavOpened),
                        'sidenav-collapsed': isShowingIconsOnlyBar && !isSidenavOpened
                    }"
                    (mouseenter)="onSidenavMouseEnter()"
                    (mouseleave)="onSidenavMouseLeave()"
            >
                <app-side-nav-panel
                        *ngIf="!isSettingsRoute()"
                        [iconsOnlySideNavbarHover]="!isSidenavOpened"
                        (toggleSidenav)="toggleSidenav()">
                </app-side-nav-panel>

                <!-- SETTINGS SIDENAV PANEL -->
                <app-settings-side-nav-panel
                        *ngIf="isSettingsRoute()"
                        [iconsOnlySideNavbarHover]="!isSidenavOpened"
                        (toggleSidenav)="toggleSidenav()">
                </app-settings-side-nav-panel>
            </mat-sidenav>
            <mat-sidenav-content>
                <main class="main-content" [ngClass]="isLoggedIn ? 'logged-Cont' : ''">
                    <router-outlet></router-outlet>
                    <div *ngIf="isLoggedIn" (click)="startChatInteraction()">
                        <img class="chatbot-toggle-btn" src="assets/img-and-icons/chat.png"
                             alt="">
                    </div>
                    @defer (on immediate) {
                        @if (isLoggedIn) {
                            <app-chatbot-panel></app-chatbot-panel>
                        }
                    }
                </main>
            </mat-sidenav-content>
        </mat-sidenav-container>
    }
</div>

<!-- Always rendered components -->
<app-custom-spinner></app-custom-spinner>

<!-- Push preview container - hidden for document routes -->
@if (!isDocumentRoute()) {
    <app-push-preview-container
            (openTray)="onOpenNotificationTray()"
            (notificationClick)="onPreviewClick($event)"
    ></app-push-preview-container>
}

<app-no-connection-found [isUserDeviceOnline]="isUserDeviceOnline"></app-no-connection-found>
